module.exports = __webpack_public_path__ + "static/media/ic_shapes_inverse.5b073a98.svg";